import { render, staticRenderFns } from "./Roadmap.vue?vue&type=template&id=4a513d98&scoped=true&"
import script from "./Roadmap.vue?vue&type=script&lang=js&"
export * from "./Roadmap.vue?vue&type=script&lang=js&"
import style0 from "./Roadmap.vue?vue&type=style&index=0&id=4a513d98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a513d98",
  null
  
)

export default component.exports